import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '@proximus/ng-common';

@Pipe({
  name: 'mprdTranslate',
})
export class MprdTranslatePipe implements PipeTransform {
  constructor(private languageService: LanguageService) {}

  transform(value: any, args?: any): any {
    if (value && value[this.languageService.getSelectedLanguage()]) {
      return value[this.languageService.getSelectedLanguage()];
    }
    return null;
  }
}
